import Modal from './modals';
const sections = document.querySelectorAll('section.hero');
sections.forEach(section => {
    const modalEl = section.querySelector('.modal');
    const videoEl = section.querySelector('video');
    if (!modalEl || !videoEl) {
        return;
    }
    const modal = new Modal(modalEl);
    // Attach close actions
    ['.modal-bg-fade', '.btn.is-modal-close'].forEach(selector => {
        section.querySelector(selector)?.addEventListener('click', () => {
            modal.close();
            videoEl.pause();
        });
    });
    // Attach open actions
    section.querySelector('.modal-btn')?.addEventListener('click', () => {
        const overlayEl = section.querySelector('.overlay');
        modal.open();
        if (overlayEl) {
            overlayEl.remove();
        }
        videoEl.src = videoEl.dataset.src;
        videoEl.controls = true;
        videoEl.load();
        videoEl.play();
    });
});
